import { authorize, AutoLogout } from '@smartapp/auth-lib'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth'
import * as firebaseui from 'firebaseui'
import { Settings } from 'luxon'
import './registerServiceWorker'
import i18n from './i18n'

const locale = window.navigator.language.split('-')[0]
if (i18n.global.availableLocales.includes(locale)) i18n.global.locale.value = locale
Settings.defaultLocale = i18n.global.locale.value

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  application: process.env.VUE_APP_APP_NAME,
  country: process.env.VUE_APP_COUNTRY,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
}

export const globalProperties = {}
const app = initializeApp(config)
getAnalytics(app)

export const logout = () => {
  void signOut(auth).then(() => {
    location.reload()
  })
}

const date = new Date().getDate().toString()
if (window.location.pathname === '/tc57') {
  localStorage.setItem('tc57', date)
}
const isTC57 = localStorage.getItem('tc57') === date

const TIMEOUTTC57 = 30 * 60 * 1000 //30min
const TIMEOUTDEFAULT = 10 * 60 * 60 * 1000 //10h
const logoutTimeout = isTC57 ? TIMEOUTTC57 : TIMEOUTDEFAULT

let interval

const ui = new firebaseui.auth.AuthUI(getAuth())
const auth = getAuth()

onAuthStateChanged(auth, async firebaseUser => {
  if (firebaseUser) {
    clearInterval(interval)
    const autologout = new AutoLogout(logout, logoutTimeout)
    authorize(config, firebaseUser, process.env.VUE_APP_BACKEND_SMART_AUTH)
      .then(({ user, roles, userCountry }) => {
        autologout.start()
        globalProperties.firebaseUser = firebaseUser
        globalProperties.user = user
        globalProperties.roles = roles
        globalProperties.isTC57 = isTC57
        globalProperties.userCountry = userCountry
        globalProperties.isUserFranchise = user?.site?.siteCurrentContract === 'FRA' || user?.employeeType === 'Affiliate'
        globalProperties.isUserCentrale = user?.site?.siteType === 'HO'
        globalProperties.halloween = new Date().getMonth() === 9 && window.innerWidth >= 1200

        import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => {
          createApp.createApp({ firebaseUser, user, roles })
        })
      })
      .catch(reason => {
        if (reason.status === 403) {
          void import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => {
            createApp.createForbiddenApp(firebaseUser, reason.user, reason.roles)
          })
        } else if (reason.status) {
          window.location.href = '/error.html'
        }
      })
  } else {
    AutoLogout.setExpirationCookie()
    interval = window.setInterval(() => AutoLogout.setExpirationCookie(), 10 * 60 * 1000)
    ui.start('#firebase-ui', {
      signInFlow: 'popup',
      signInSuccessUrl: '/',
      signInOptions: [
        {
          provider: 'oidc.pass',
          buttonColor: '#2A2A2D',
          iconUrl: 'null',
          fullLabel: i18n.global.t('loginTo'),
          providerName: 'Mesh'
        }
      ]
    })
  }
})

